import { Avatar, Grid, Stack } from "@mui/material";
import { AppGlobalClassKeys } from "app/appGlobalStyles";
import { AppImages } from "app/appImages";
import { MprcLink } from "components";
import { IconPublicationThread } from "components/icons/IconPublicationThread";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { FeedItemDto, PublicationType } from "generated/CoreApi_v1";
import { TFunction } from "i18next";
import { Formaters } from "lib/Formaters";
import { useSession } from "providers/SessionProvider";
import { useModalUserProfile } from "providers/UserProfileProvider";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { useCardContext } from "views/knowledge/components/card/CardBuilder";

interface FeedAuthor {
    name: string;
    thumbnailUrl: string;
    actionDate: Date | null;
    actionFormatted: string;
}

export function resolveAuthor(pub: FeedItemDto, t: TFunction, currentUserId: string): FeedAuthor {
    const actionName = pub.isDraft
        ? t("Feed.Card.Common.SaveDraftOnText")
        : pub.publicationType == PublicationType.Question
            ? t("Feed.Card.Common.AskedOnText")
            : pub.publicationType == PublicationType.Answer
                ? t("Feed.Card.Common.AnsweredhOnText")
                : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor == null
                    ? t("Feed.Card.Common.ModifiedOnText")
                    : pub.contentModifiedDate?.getTime() != pub.createdOn.getTime() && pub.supervisor != null
                        ? t("Feed.Card.Common.EditedOnText")
                        : t("Feed.Card.Common.PublishOnText");

    const actionDate = pub.isDraft
        ? pub.createdOn
        : pub.contentModifiedDate != pub.createdOn
            ? pub.contentModifiedDate
            : pub.createdOn;

    const avatarImg = pub.institutional != null
        ? pub.institutional.thumbnailUrl ?? AppImages.KnowledgeInstitutionalThumbnail
        : pub.author.thumbnailUrl;

    const authorName = pub.institutional != null
        ? pub.institutional.name
        : pub.isAnonymous
            ? t("Feed.Card.Common.AnonymousAuthorName")
            : pub.author.userId === currentUserId
                ? t("shared:Literal.You")
                : pub.author.name;

    var feedAuthor: FeedAuthor = {
        name: authorName,
        actionDate: actionDate,
        actionFormatted: `${actionName} ${Formaters.relativeTime(actionDate)}`,
        thumbnailUrl: avatarImg
    };

    return feedAuthor;
}

///
export const DefaultAuthor = () => {
    const { pub } = useCardContext();
    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();
    const location = useLocation();
    const { showUser } = useModalUserProfile();
    const session = useSession();

    var author = resolveAuthor(pub, t, session.user.userId);

    const RenderAuthorName = (
        <MprcFeedTypography variant="authorPrimary" component="div" noWrap>
            <span title={author.name}>{author.name}</span>
            {
                pub.supervisor != null &&
                <span> ({t("Feed.Card.Common.EditedBySupervisorText")})</span>
            }
        </MprcFeedTypography>
    );

    return (
        <>
            <Grid container justifyContent="center" alignItems="center" spacing={1} width="100%">
                {!pub.isAnonymous &&
                    <Grid>
                        {pub.institutional != null
                            ? <Avatar src={author.thumbnailUrl} title={author.thumbnailUrl} />
                            : <Avatar
                                className={AppGlobalClassKeys.clickable}
                                title={author.name}
                                src={author.thumbnailUrl}
                                onClick={
                                    () => showUser(
                                        pub.author.userId,
                                        () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                    )
                                }
                            />
                        }
                    </Grid>
                }
                <Grid size="grow" overflow="hidden">
                    {
                        (pub.institutional != null || pub.isAnonymous)
                            ? RenderAuthorName
                            : (
                                <Stack direction="row" alignItems="center" gap={1}>
                                    <MprcLink
                                        onClick={
                                            () => showUser(
                                                pub.author.userId,
                                                () => navigate(document.location.search, { replace: true, state: { ...(location.state ?? {}), publicationId: pub.publicationId } })
                                            )
                                        }
                                    >
                                        {RenderAuthorName}
                                    </MprcLink>
                                    {pub.isThread && <span>&nbsp;<IconPublicationThread /></span>}
                                </Stack>
                            )
                    }
                    <MprcFeedTypography variant="authorSecondary" component="div" noWrap>
                        <span>{author.actionFormatted}</span>
                    </MprcFeedTypography>
                </Grid>
            </Grid >
        </>
    );
};
